import type {
  LatLng,
  LeafletEventHandlerFnMap,
  LeafletMouseEvent,
} from 'leaflet';
import { Popup } from 'rc-tooltip';
import { useMemo } from 'react';
import { Marker, useMapEvents } from 'react-leaflet';
import { Icon } from 'leaflet';
import MapDuotone from '@/Assets/Img/map_duotone.png';
import type { ILocation } from '@/Interfaces/Data';

interface MapLocationMakerProps {
  mainPosition: ILocation;
  objectPosition?: ILocation;
  onChangePin(position: LatLng): void;
  popupLabel: string;
}

function MapLocationMaker({
  onChangePin,
  objectPosition,
  mainPosition,
  popupLabel,
}: MapLocationMakerProps) {
  const pointerIcon = new Icon({
    iconUrl: MapDuotone,
    iconAnchor: [15, 45],
    popupAnchor: [10, -44],
    iconSize: [30, 45],
  });

  const eventHandlers: LeafletEventHandlerFnMap = useMemo(
    () => ({
      dragend(value) {
        const marker = value;
        const newPosition = marker.target._latlng;
        onChangePin(newPosition);
      },
    }),
    [],
  );

  const map = useMapEvents({
    click() {
      map.addEventListener('click', value => {
        const marker = value as LeafletMouseEvent;

        const newPosition = marker.latlng;

        onChangePin(newPosition);
      });
    },
  });

  return mainPosition === null ? null : (
    <Marker
      position={[
        objectPosition?.latitude || mainPosition.latitude,
        objectPosition?.longitude || mainPosition.longitude,
      ]}
      draggable
      eventHandlers={eventHandlers}
      icon={pointerIcon}
    >
      <Popup>{popupLabel}</Popup>
    </Marker>
  );
}

export { MapLocationMaker };
